<template>
    <div id="canImg" class="image-generator">

      <!-- ★ 流程操作列（最顯眼區域） -->
      <div class="workflow-bar">
        <div class="workflow-title">🖼️ 活動宣傳圖片製作</div>
        
        <div class="workflow-steps">
          <!-- STEP 1 -->
          <div class="wf-step" :class="{ active: currentStep >= 1, done: currentStep > 1 }">
            <div class="wf-badge">STEP 1</div>
            <input type="file" @change="uploadImage" ref="fileInput" style="display: none;" accept="image/*" />
            <button class="wf-btn btn-blue" @click="triggerFileInput">
              <span class="wf-icon">📁</span>
              <span class="wf-label">選取圖片</span>
            </button>
          </div>

          <div class="wf-arrow">▶</div>

          <!-- STEP 2 -->
          <div class="wf-step" :class="{ active: currentStep >= 2, done: currentStep > 2 }">
            <div class="wf-badge">STEP 2</div>
            <div class="wf-layout-btns">
              <button
                class="wf-btn btn-outline"
                :class="{ selected: imageDisplayMode === 'center' }"
                @click="setDisplayMode('center')"
                :disabled="!currentImageSrc"
              >
                <span class="wf-icon">⬛</span>
                <span class="wf-label">居中顯示</span>
              </button>
              <button
                class="wf-btn btn-outline"
                :class="{ selected: imageDisplayMode === 'fill' }"
                @click="setDisplayMode('fill')"
                :disabled="!currentImageSrc"
              >
                <span class="wf-icon">🔳</span>
                <span class="wf-label">填滿畫面</span>
              </button>
            </div>
          </div>

          <div class="wf-arrow">▶</div>

          <!-- STEP 3 -->
          <div class="wf-step" :class="{ active: currentStep >= 3 }">
            <div class="wf-badge">STEP 3</div>
            <button class="wf-btn btn-green" @click="mergeLayers" :disabled="!currentImageSrc">
              <span class="wf-icon">💾</span>
              <span class="wf-label">下載圖片</span>
            </button>
          </div>
        </div>
      </div>

      <!-- 下載完成提示 -->
      <div class="upload-tip" v-if="downloadCompleted">
        <span class="tip-icon">✅</span>
        <span>圖片已下載完成！請將剛才下載的圖片</span>
        <strong>「上傳當成本次活動宣傳照」</strong>
      </div>

      <!-- Canvas 預覽 -->
      <div class="canvas-wrap">
        <canvas ref="layer1" width="1080" height="540" class="preview-canvas"></canvas>
        <canvas ref="layer2" width="1080" height="540" style="display: none;"></canvas>
        <div v-if="!currentImageSrc" class="canvas-empty">
          <p>📤 請先點擊上方「選取圖片」開始製作</p>
        </div>
      </div>

    </div>
</template>
  
  <script>
  export default {
    name: 'Canvas_main', 
    data() {
      return {
        imageDisplayMode: 'center', // 預設顯示模式
        currentImageSrc: null,
        currentStep: 1, // 當前步驟
        downloadCompleted: false, // 是否已完成下載
      };
    },       
    methods: {
      // 設定顯示模式的新方法
      setDisplayMode(mode) {
        if (!this.currentImageSrc) return;
        
        this.imageDisplayMode = mode;
        this.currentStep = 3; // 進入第三步
        
        if (mode === 'center') {
          this.displayImageOnCanvas2(this.currentImageSrc);
        } else {
          this.displayImageOnCanvas1(this.currentImageSrc);
        }
      },
      clear(){
        const layer1 = this.$refs.layer1.getContext('2d');
        const layer2 = this.$refs.layer2.getContext('2d');
        const width = this.$refs.layer1.width;
        const height = this.$refs.layer1.height;
        // 清除兩個 Canvas 層的內容
        layer1.clearRect(0, 0, width, height);
        layer2.clearRect(0, 0, width, height);
      },      
      triggerFileInput() {
        // 觸發隱藏的文件輸入元素
        this.$refs.fileInput.click();
        },        
        uploadImage(event) {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = e => {
            this.currentImageSrc = e.target.result;
            this.currentStep = 2; // 進入第二步
            this.downloadCompleted = false; // 重置下載狀態
            this.displayImageOnCanvas2(this.currentImageSrc); // 預設居中顯示
          };
          reader.readAsDataURL(file);
        }
      },  
      
      onSelectChange() {
        // 當選擇變化時，重新繪製圖片
        if(this.currentImageSrc){
          if(this.imageDisplayMode==='center'){
          this.displayImageOnCanvas1(this.currentImageSrc);
          }else{
            this.displayImageOnCanvas2(this.currentImageSrc);
          }	
        }
      },     

      displayImageOnCanvas1(imageSrc) {
        const layer1 = this.$refs.layer1.getContext('2d');
        const layer2 = this.$refs.layer2.getContext('2d');
        const targetWidth = 1080;
        const targetHeight = 540;

        const img = new Image();
        img.onload = () => {
          // 先在 layer2 繪製純白色底色
          layer2.canvas.width = targetWidth;
          layer2.canvas.height = targetHeight;
          layer2.fillStyle = '#FFFFFF'; // 純白色
          layer2.fillRect(0, 0, targetWidth, targetHeight);

          // 再在 layer1 繪製圖片
          layer1.canvas.width = targetWidth;
          layer1.canvas.height = targetHeight;
          layer1.clearRect(0, 0, targetWidth, targetHeight);
          // 直接將圖片縮放到整個 Canvas 的尺寸
          layer1.drawImage(img, 0, 0, targetWidth, targetHeight);
        };
        img.src = imageSrc;
      },


      displayImageOnCanvas2(imageSrc) {
            const layer1 = this.$refs.layer1.getContext('2d');
            const layer2 = this.$refs.layer2.getContext('2d');
            const targetWidth = 1080;
            const targetHeight = 540;

            const img = new Image();
            img.onload = () => {
                // 計算縮放比例以保持圖片比例
                const scale = Math.min(targetWidth / img.width, targetHeight / img.height);

                // 計算新尺寸
                const scaledWidth = img.width * scale;
                const scaledHeight = img.height * scale;

                // 計算圖片居中位置
                const x = (targetWidth - scaledWidth) / 2;
                const y = (targetHeight - scaledHeight) / 2;

                // 先在 layer2 繪製純白色底色
                layer2.canvas.width = targetWidth;
                layer2.canvas.height = targetHeight;
                layer2.fillStyle = '#FFFFFF'; // 純白色
                layer2.fillRect(0, 0, targetWidth, targetHeight);

                // 再在 layer1 繪製圖片
                layer1.canvas.width = targetWidth;
                layer1.canvas.height = targetHeight;
                layer1.clearRect(0, 0, targetWidth, targetHeight); // 清除之前的繪製
                layer1.drawImage(img, x, y, scaledWidth, scaledHeight); // 居中並縮放繪製圖片
            };
            img.src = imageSrc;
        },


      /*mergeLayers() {
        const layer1 = this.$refs.layer1;
        const layer2 = this.$refs.layer2.getContext('2d');

        // 先清除 layer2 的內容
        layer2.clearRect(0, 0, layer2.canvas.width, layer2.canvas.height);

        // 然後將 layer1（圖片）繪製到 layer2（底色）之上
        layer2.drawImage(layer1, 0, 0);

        // 下載合併後的圖像
        const link = document.createElement('a');
        link.download = 'merged-image.png';
        link.href = layer2.canvas.toDataURL('image/png');
        link.click();
        }*/

        mergeLayers() {
          const layer1 = this.$refs.layer1;
          const layer2Canvas = this.$refs.layer2;
          const layer2 = layer2Canvas.getContext('2d');

          // 獲取 layer2 Canvas 的寬高
          const width = layer2Canvas.width;
          const height = layer2Canvas.height;

          // 先清除 layer2 的內容
          layer2.clearRect(0, 0, width, height);

          // 在 layer2 上設置白色背景
          //layer2.fillStyle = 'white';
          // 創建線性漸層作為背景色
          const gradient = layer2.createLinearGradient(0, 0, width, 0); // 水平漸層
          gradient.addColorStop(0, '#d2e9f1'); // 起始顏色
          gradient.addColorStop(0.5, 'white'); // 中間顏色
          gradient.addColorStop(1, '#d7f6ee'); // 結束顏色

          // 將漸層設置為背景色並填充矩形
          layer2.fillStyle = gradient;
          layer2.fillRect(0, 0, width, height);

          // 設置陰影效果
          //layer2.shadowColor = 'rgba(97, 100, 101, 0.4)'; // 半透明黑色陰影
          //layer2.shadowBlur = 15; // 模糊程度
          //layer2.shadowOffsetX = 5; // 水平偏移量
          //layer2.shadowOffsetY = 5; // 垂直偏移量
          // 將 layer1（圖片）繪製到 layer2（漸層背景）之上

          // 然後將 layer1（圖片）繪製到 layer2（底色）之上

          // 繪製黃色長方形底色
          layer2.fillStyle = '#f6f6c2';  
          layer2.fillRect(0, height - 17, width, 25); // 黃色長方形高度為25像素

          // 繪製綠色長方形底色
          layer2.fillStyle = '#c8f6c2';
          layer2.fillRect(0, height - 10, width, 25); // 綠色長方形高度為25像素

          layer2.drawImage(layer1, 0, 0);

          // 調整圖像質量以減少檔案大小
          let quality = 1.0; // 初始質量為最高
          let dataUrl = layer2Canvas.toDataURL('image/jpeg', quality);

          // 檢查檔案大小，並適當調整質量
          while (dataUrl.length > 2 * 1024 * 1024 && quality > 0.1) {
            // 大於 2MB 且質量高於最低閾值
            quality -= 0.1;
            dataUrl = layer2Canvas.toDataURL('image/jpeg', quality);
          }

          // 下載合併後的圖像
          const link = document.createElement('a');
          link.download = 'merged-image.jpg'; // 更改為 jpg
          link.href = dataUrl;
          link.click();
          
          // 設定下載完成狀態
          this.downloadCompleted = true;
        },

        drawRoundedRect(ctx, x, y, width, height, radius) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
      }

    }
  };
  </script>
  
  <style scoped>
/* 整體容器 */
.image-generator {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* ★ 流程操作列 */
.workflow-bar {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 16px 16px 0 0;
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
  box-shadow: 0 4px 20px rgba(37, 99, 235, 0.3);
}

.workflow-title {
  text-align: center;
  color: rgba(255,255,255,0.9);
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  margin-bottom: 1rem;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

/* 每個步驟區塊 */
.wf-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.wf-step.active,
.wf-step.done {
  opacity: 1;
}

.wf-badge {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: rgba(255,255,255,0.7);
  background: rgba(255,255,255,0.15);
  padding: 2px 8px;
  border-radius: 20px;
}

.wf-step.done .wf-badge {
  background: rgba(16, 185, 129, 0.4);
  color: #a7f3d0;
}

/* 工作流按鈕 */
.wf-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.wf-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  transform: none !important;
}

.btn-blue {
  background: #ffffff;
  color: #1d4ed8;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
}

.btn-blue:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.25);
  background: #eff6ff;
}

.btn-green {
  background: #10b981;
  color: #ffffff;
  box-shadow: 0 3px 12px rgba(16,185,129,0.4);
}

.btn-green:hover:not(:disabled) {
  transform: translateY(-2px);
  background: #059669;
  box-shadow: 0 6px 18px rgba(16,185,129,0.5);
}

/* 佈局選擇按鈕群 */
.wf-layout-btns {
  display: flex;
  gap: 0.5rem;
}

.btn-outline {
  background: rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.85);
  border: 2px solid rgba(255,255,255,0.3);
  box-shadow: none;
}

.btn-outline:hover:not(:disabled) {
  background: rgba(255,255,255,0.2);
  border-color: rgba(255,255,255,0.6);
  transform: translateY(-2px);
}

.btn-outline.selected {
  background: #ffffff;
  color: #1d4ed8;
  border-color: #ffffff;
  box-shadow: 0 3px 12px rgba(0,0,0,0.2);
}

.wf-icon {
  font-size: 1.1rem;
}

.wf-label {
  font-size: 0.95rem;
}

/* 箭頭分隔 */
.wf-arrow {
  color: rgba(255,255,255,0.4);
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 1.2rem;
}

/* ★ 下載完成提示 */
.upload-tip {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #d1fae5 0%, #ecfdf5 100%);
  border-left: 5px solid #10b981;
  font-size: 0.95rem;
  color: #065f46;
  animation: slideDown 0.4s ease-out;
}

.upload-tip strong {
  color: #047857;
  font-size: 1rem;
}

.tip-icon {
  font-size: 1.2rem;
  flex-shrink: 0;
}

/* Canvas 預覽區域 */
.canvas-wrap {
  position: relative;
  background: #f1f5f9;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
  text-align: center;
  min-height: 120px;
}

.preview-canvas {
  display: block;
  max-width: 100%;
  height: auto;
}

.canvas-empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #94a3b8;
  font-size: 1rem;
  text-align: center;
  pointer-events: none;
}

.canvas-empty p {
  margin: 0;
  padding: 2rem;
}

/* 響應式 */
@media (max-width: 700px) {
  .workflow-bar {
    border-radius: 12px 12px 0 0;
    padding: 1rem;
  }

  .workflow-steps {
    flex-direction: column;
    gap: 1rem;
  }

  .wf-arrow {
    transform: rotate(90deg);
  }

  .wf-layout-btns {
    flex-direction: column;
  }
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>

